import { defineCapability } from 'nest/capabilities';
import { args } from 'nest/common/args';

export const UPDATE_BELL_ICON_COUNT_CAP = defineCapability({
  name: 'UPDATE_BELL_ICON_COUNT_CAP' as const,
  args: {
    count: args.number(),
  },
});
